export const getGravesData = () => ({
  name: "Graves",
  region: "Bordeaux",
  country: "France",
  description: "Les Graves produisent des vins rouges et blancs de qualité, avec une forte proportion de vins blancs secs. Cette région bénéficie d'un terroir favorable et d'une longue tradition viticole.",
  type: "subregion",
  area: "4,800 ha",
  production: "220,000 hectolitres",
  mapAreas: [
    { region: "Graves", x: -0.6, y: 44.7, color: "#4B164C", size: 5 }
  ],
  characteristics: {
    climate: "Climat océanique tempéré, étés chauds, hivers doux",
    soil: "Sols de graves et argiles, excellente structure",
    viticulture: "Rendements limités, élevage en barriques"
  },
  wineStyles: {
    red: "Vins rouges structurés et équilibrés",
    white: "Vins blancs secs, aromatiques et complexes"
  },
  history: "La viticulture dans les Graves remonte à l'époque romaine. Au Moyen Âge, les moines ont développé la viticulture. La région a bénéficié de l'influence bordelaise tout en gardant son identité propre. Aujourd'hui, les Graves sont reconnues pour leurs vins de qualité et leur diversité.",
  foodPairing: "Poissons, fruits de mer, volailles, fromages de chèvre, cuisine française",
  grapeVarieties: [
    {
      name: "Cabernet Sauvignon",
      percentage: "45%",
      description: "Cépage principal pour les vins rouges, apportant structure et tanins",
      characteristics: "Structuré, tanins fermes, notes de cassis et de cèdre",
      wineStyles: "Sec, plein-corps, tannique"
    },
    {
      name: "Merlot",
      percentage: "35%",
      description: "Cépage d'assemblage, apportant rondeur et fruité",
      characteristics: "Fruité, tanins doux, structure équilibrée",
      wineStyles: "Sec, moyen-corps, fruité"
    },
    {
      name: "Sauvignon Blanc",
      percentage: "15%",
      description: "Cépage blanc principal, pour vins secs",
      characteristics: "Aromatique, acidité vive, notes d'agrumes",
      wineStyles: "Sec, léger, aromatique"
    },
    {
      name: "Sémillon",
      percentage: "5%",
      description: "Cépage blanc d'assemblage, pour vins secs",
      characteristics: "Riche, miel, notes de fruits secs",
      wineStyles: "Sec, moyen-corps, complexe"
    }
  ],
  subregions: {
    "graves-rouge": {
      name: "Graves Rouge",
      description: "Zone de production des vins rouges",
      characteristics: {
        climate: "Climat océanique tempéré",
        soil: "Sols de graves",
        viticulture: "Viticulture traditionnelle"
      },
      grapeVarieties: {
        red: ["Cabernet Sauvignon", "Merlot", "Cabernet Franc"]
      },
      wineStyles: {
        red: "Vins rouges structurés et équilibrés"
      },
      foodPairing: "Viandes rouges, gibier, fromages affinés"
    },
    "graves-blanc": {
      name: "Graves Blanc",
      description: "Zone de production des vins blancs",
      characteristics: {
        climate: "Climat optimal pour les blancs",
        soil: "Sols argilo-calcaires",
        viticulture: "Viticulture traditionnelle"
      },
      grapeVarieties: {
        white: ["Sauvignon Blanc", "Sémillon", "Muscadelle"]
      },
      wineStyles: {
        white: "Vins blancs secs, aromatiques et complexes"
      },
      foodPairing: "Poissons, fruits de mer, volailles"
    }
  }
}); 